import { Observable } from 'rxjs';

import { TableData } from '../components/p-table/model/table-data.model';
import { CaseFilterType } from '../constants/constants';
import { RiskCaseType } from '../models/risk-case-type.model';

export abstract class HomeService<T, P = unknown> {
  abstract getData(caseType?: RiskCaseType, type?: CaseFilterType, params?: P): Observable<TableData<T[]>>;
}
